
// SVG Icon: closed
export default { id: "terriajs-closed" };
export const id = "terriajs-closed";
export const name = "closed";
